<template>

    <div class="video-item flex justify-between items-start mt-3 relative">
        <div class="absolute -top-2 left-0 text-xs" v-if="can_watch_raw">Your recording is being processed… Video will
            reload once done.</div>
        <div class="flex flex-grow flex-col gap-y-3 mt-3">
            <div class="flex w-3/5 h-3 bg-gray-200 rounded-full skeleton-box"></div>
            <div class="w-1/5 h-3 bg-gray-200 rounded-full skeleton-box"></div>
            <div class="w-1/12  h-3 bg-gray-200 rounded-full skeleton-box" v-if="!is_visitor"></div>
        </div>

        <div class="z-10">
            <div class="flex items-center gap-x-3">
                <a v-if="is_visitor" href="#" @click.prevent="action_link()" v-clipboard:copy="video.sharing_link"
                    title="Share Link"
                    class="rounded-md text-white hover:bg-birdie-blue-dark bg-birdie-blue  font-semibold shadow-sm focus-visible:outline-none flex items-center flex-block px-3 py-2 text-left text-nowrap text-sm gap-x-2 flex-shrink-0">
                    <LinkIcon class="h-4 w-4" /> Copy Link
                </a>
                <a v-else href="#" @click.prevent="action_link()" v-clipboard:copy="video.sharing_link"
                    title="Share Link"
                    class="rounded-lg h-8 flex justify-start items-center text-white bg-birdie-grey-medium hover:bg-birdie-blue px-3 text-sm w-32 gap-x-2">
                    <LinkIcon class="size-4" /> Copy Link
                </a>

            </div>
        </div>
    </div>
</template>



<script>


import { LinkIcon } from "@heroicons/vue/20/solid";



export default {

    props: ['the_video', 'is_visitor', 'can_watch_raw'],

    components: {
        LinkIcon
    },

    created: function () {

    },

    beforeUnmount() {

    },

    data() {
        return {
            video: this.the_video,
        }
    },

    mounted: function () {

    },

    methods: {

        action_link: function () {
            this.EventBus.emit('copied', '');
        }
    },

    computed: {

    }
}

</script>

<style scoped>
.skeleton-box {
    position: relative;
}

.skeleton-box::after {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    transform: translateX(-100%);
    background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
    animation: shimmer 2s infinite;
    content: '';
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}
</style>
